import { api } from "boot/axios";

export default () => {
  const getMarketDepth = (payload, onMessage) => {
    let socket = new WebSocket(
      `${process.env.MARKET_DEPTH_WS}/md/?auth=${payload.auth_token}`
    );

    socket.onopen = () => {};

    socket.addEventListener("message", (event) => {
      try {
        const data = JSON.parse(event.data);
        onMessage(data);
      } catch (err) {
        console.error("Error parsing data:", err);
      }
    });

    socket.onerror = (err) => {};
    socket.onclose = (event) => {};

    return socket;
  };

  const asOfMarketDepth = async (clientId) => {
    try {
      const res = await api.get(`md/data/market-depth/${clientId}/`);
      return res.data;
    } catch (e) {
      return new Error(e);
    }
  };

  const asOfMarketDepthTotal = async (clientId) => {
    try {
      const res = await api.get(`md/data/market-depth-total/${clientId}/`);
      return res.data;
    } catch (e) {
      return new Error(e);
    }
  };

  const deleteClient = (payload) => {
    return new Promise((resolve, reject) => {
      api.delete(`/partners/details/${payload.id}/`).then((res) => {
        resolve(res.data);
      });
    });
  };

  const tmsUpdatePassword = (payload) => {
    return new Promise((resolve, reject) => {
      api
        .post(`/partners/details/password/update/${payload.id}/`, payload)
        .then((res) => {
          resolve(res.data);
        });
    });
  };

  const patchDetails = (payload) => {
    return new Promise((resolve, reject) => {
      api.patch(`/partners/details/${payload.id}/`, payload).then((res) => {
        resolve(res.data);
      });
    });
  };

  const tmsRegister = (payload) => {
    return new Promise((resolve, reject) => {
      api
        .post("/partners/details/", payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  const tmsLogin = async (payload) => {
    const data = api.post("/partners/client/login/", payload);
    return data;
  };

  const tmsLogout = (payload) => {
    return;
    // return new Promise((resolve, reject) => {
    //   api.post("/partners/client/logout//", payload).then((res) => {
    //     resolve(res.data);
    //   });
    // });
  };

  const tmsDetails = () => {
    return new Promise((resolve, reject) => {
      api.get("/partners/details/").then((res) => {
        resolve(res.data);
      });
    });
  };

  const submitClientStocks = (payload) => {
    return new Promise((resolve, reject) => {
      api
        .post("/partners/stocks/", payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  const patchWatchlist = (payload) => {
    return new Promise((resolve, reject) => {
      api
        .patch(`/partners/stocks/${payload.client_id}/${payload.id}/`, payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  const deleteWatchlist = (payload) => {
    return new Promise((resolve, reject) => {
      api
        .delete(`/partners/stocks/${payload.client_id}/${payload.id}/`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  const tmsClientStocks = () => {
    return new Promise((resolve, reject) => {
      api.get("/partners/stocks/").then((res) => {
        resolve(res.data);
      });
    });
  };

  const allBankList = async () => {
    try {
      const res = await api.get("/portfolio/bank/");
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  };

  const postInitialSetup = async (InitialSetupData) => {
    try {
      const data = await api.post("/portfolio/v2/initial/", InitialSetupData);
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    postInitialSetup,
    allBankList,
    asOfMarketDepth,
    asOfMarketDepthTotal,
    deleteClient,
    tmsUpdatePassword,
    patchDetails,
    getMarketDepth,
    tmsRegister,
    tmsLogin,
    tmsLogout,
    tmsDetails,
    submitClientStocks,
    patchWatchlist,
    deleteWatchlist,
    tmsClientStocks,
  };
};
